import { render } from "./MapDisplayPoint.vue?vue&type=template&id=10c929ae"
import script from "./MapDisplayPoint.vue?vue&type=script&lang=js"
export * from "./MapDisplayPoint.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__